import { registerPlugin } from '@capacitor/core';

import type { CapacitorFirebaseMFAPlugin } from './definitions';

const CapacitorFirebaseMFA = registerPlugin<CapacitorFirebaseMFAPlugin>(
  'CapacitorFirebaseMFA',
);

export * from './definitions';
export { CapacitorFirebaseMFA };
